import Head from "next/head"
import React from "react"
import styled, { css } from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import Table from "~/components/organisms/Table"
import { IsPC, IsMobile } from "~/consts/style-mixins"
import { internalLink, staticPath } from "~/services/helper"

export default class SctaNotation extends React.Component {
  render() {
    const crumbs = [
      {
        name: "特定商取引法に基づく表示",
        link: internalLink(`/scta-notation`),
      },
    ]

    return (
      <>
        <Head>
          <title>特定商取引法に基づく表示 | Infra</title>
          <meta property="og:title" content="特定商取引法に基づく表示 | Infra" />
          <meta property="og:description" content="特定商取引法に基づく表示です。" />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header showTab logoType="Plain" />
        <StyledContainerWrapper>
          <Container size="Medium">
            <Typography type="SubHero">特定商取引法に基づく表示</Typography>
            <div>
              <StyledTableWrapper>
                <Table
                  items={[
                    {
                      name: "販売業者",
                      content: "株式会社Legaseed",
                    },
                    {
                      name: "代表責任者",
                      content: "近藤 悦康",
                    },
                    {
                      name: "所在地",
                      content: "〒108-0075\n東京都港区港南2-16-3 品川グランドセントラルタワー24F",
                    },
                    {
                      name: "電話番号",
                      content: "03-6433-1288",
                    },
                    {
                      name: "電話受付時間",
                      content: "9:00 ~ 18:00",
                    },
                    {
                      name: "公開メールアドレス",
                      content: "info@legaseed.co.jp",
                    },
                    {
                      name: "販売価格",
                      content: "商品紹介ページをご参照ください。",
                    },
                    {
                      name: "商品代金以外の必要料金",
                      content: "消費税、銀行振込の場合の振込手数料",
                    },
                    {
                      name: "商品の引き渡し時期",
                      content: "利用教材については、開講時にお渡しいたします。",
                    },
                    {
                      name: "サービス利用開始可能時期",
                      content: "受講契約書の締結をもって、講座の予約完了となります。",
                    },
                    {
                      name: "お支払方法",
                      content: "銀行振込、クレジットカード",
                    },
                    {
                      name: "お支払時期",
                      content: "開講の前日までにお支払いください。",
                    },
                    {
                      name: "返品・交換・キャンセル等",
                      content: "サービスの特性上、返品やキャンセルはお受け致しかねます。",
                    },
                  ]}
                />
              </StyledTableWrapper>
            </div>
          </Container>
        </StyledContainerWrapper>
        <Breadcrumb crumbs={crumbs} />
        <Footer />
      </>
    )
  }
}

const StyledContainerWrapper = styled.div`
  ${IsPC(css`
    padding: 48px 0;
  `)}
  ${IsMobile(css`
    padding: 24px 0 32px;
  `)}
`
const StyledTableWrapper = styled.div`
  margin: 16px 0 32px;
`
